<template>
  <div class="page-wrap">

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="fa fa-chart-bar"></i></div>
          <div>
            <div class="panel-title">
              Appointment Summary
              <span class="count-badge" v-if="!load && !getLoadingData && reports.length > 0">
                {{ reports.length }} rows
              </span>
            </div>
            <div class="panel-sub">Appointment counts by service provider and service type</div>
          </div>
        </div>
      </div>

      <!-- Filters (AdvSearch) -->
      <div class="filter-bar">
        <adv-search
          @search="advSearch"
          :is_date_range="true"
          :is_service="true"
          :is_status="true"
          :is_job_report="false"
          :is_location="true"
          :is_admin_sp_location="false"
          :is_admin_sp="false"
          :is_payment_status="true"
          :is_location_appointment="true"
          :reportData="excelreports"
          :titleworksheet="titleworksheet"
          :json_fields="json_fields"
          :header="header"
          :report_name="'Appointment Report.xls'"
        />
      </div>

      <!-- Initial prompt -->
      <div class="state-box" v-if="load">
        <i class="fa fa-filter"></i>
        Select the search criteria above and click Search
      </div>

      <!-- Loading -->
      <div class="state-box" v-else-if="getLoadingData">
        <i class="fa fa-spinner fa-spin"></i>
        Generating report…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="reports.length === 0">
        <i class="fa fa-inbox"></i>
        No report data found for the selected criteria
      </div>

      <!-- Table -->
      <div class="table-wrap" v-else>
        <table class="rpt-table">
          <thead>
            <tr>
              <th style="width:44px;">#</th>
              <th v-for="(col, i) in columns" :key="i" :class="col.class">{{ col.label }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in reports" :key="index">
              <td class="col-num">{{ index + 1 }}</td>
              <td class="col-name">{{ item.location }}</td>
              <template v-if="search.location != 'all' && search.location != ''">
                <td
                  v-for="(service_count, i2) in item.service_data"
                  :key="i2"
                  class="col-count"
                >
                  {{ service_count.count }}
                </td>
              </template>
              <td class="col-total">{{ item.total }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr class="grand-total-row">
              <td :colspan="grandTotalColspan" class="gt-label">Grand Total</td>
              <td class="col-total gt-value">{{ total_apps }}</td>
            </tr>
          </tfoot>
        </table>
      </div>

    </div>
  </div>
</template>

<script>
import {
  FETCH_CLIENTS,
  FETCH_SP_SERVICE_APP_REPORT
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import AdvSearch from "@/includes/search/AdvSearch";

export default {
  components: { AdvSearch },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getSearchDate"]),
    total_apps() {
      return this.reports.reduce((sum, el) => sum + parseFloat(el.total), 0);
    },
    grandTotalColspan() {
      if (this.search.location !== "all" && this.search.location !== "") {
        return this.columns.length;
      }
      return 2;
    }
  },
  data() {
    return {
      search: {
        service: "all",
        date_from: "",
        date_to: "",
        location: "all",
        service_status: "all",
        payment_status: "all",
        search_text: ""
      },
      titleworksheet: "",
      getLoadingData: false,
      columns: [],
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Report", route: "" },
        { id: 3, title: "Appointment Summary", route: "" }
      ],
      reports: [],
      header: [],
      load: true,
      excelreports: [],
      json_fields: {}
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_CLIENTS);
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  },
  methods: {
    advSearch(value) {
      this.getLoadingData = true;
      this.load = false;
      const { header, search } = value;
      this.header = header;
      this.search = { ...search };
      search["sp_id"] = this.search.location;
      this.titleworksheet = search.date_from + " - " + search.date_to;

      this.$store.dispatch(FETCH_SP_SERVICE_APP_REPORT, search)
        .then(res => {
          if (search.sp_id !== "" && search.sp_id !== "all") {
            this.json_fields = { Location: "location" };
            this.columns = [{ name: "Location", width: "", label: "Location", class: "" }];
            if (res.data.length > 0) {
              res.columns.forEach(item => {
                this.json_fields[item] = item;
                this.columns.push({ name: item, width: "", label: item, class: "col-count" });
              });
              this.json_fields["Total"] = "total";
              this.columns.push({ name: "Total", width: "", label: "Total", class: "col-total" });
            }
          } else {
            this.json_fields = { "Service Provider": "location", Total: "total" };
            this.columns = [
              { name: "Service Provider", width: "", label: "Service Provider", class: "" },
              { name: "Total", width: "", label: "Total", class: "col-total" }
            ];
          }
          this.getLoadingData = false;
          this.reports = res.data;
          const data = [...res.data];
          const apps = data.reduce((s, el) => s + parseInt(el.total), 0);
          this.excelreports = [...res.data, { total: apps }];
        })
        .catch(err => {
          this.getLoadingData = false;
          this.msg = err.error;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;

.page-wrap {
  padding: 8px 0 80px;
  font-family: $font;
}

/* ── Panel ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.07);
  overflow: visible;
}

/* ── Header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: #fafbfd;
  border-bottom: 1px solid #eef0f6;
  gap: 10px;
  flex-wrap: wrap;
}

.panel-header-left { display: flex; align-items: center; gap: 12px; }

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: $blue;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.count-badge {
  font-size: 11px;
  font-weight: 600;
  color: #7a8499;
  background: #eef0f6;
  border-radius: 10px;
  padding: 1px 7px;
}

.panel-sub { font-size: 11px; color: #8a94a6; margin-top: 2px; }

/* ── Filter bar ── */
.filter-bar {
  padding: 12px 20px;
  border-bottom: 1px solid #f0f3fa;
}

/* ── States ── */
.state-box {
  text-align: center;
  padding: 52px 24px;
  color: #a0aab8;
  font-size: 13px;
  font-family: $font;
  i { font-size: 28px; display: block; margin-bottom: 10px; opacity: 0.4; }
}

/* ── Table ── */
.table-wrap { overflow-x: auto; }

.rpt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;
  table-layout: auto;

  thead tr {
    border-bottom: 2px solid #eef0f8;

    th {
      padding: 9px 12px;
      font-size: 11px;
      font-weight: 700;
      color: #7a8499;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      white-space: normal;
      word-break: break-word;
      line-height: 1.35;
      vertical-align: bottom;
      text-align: left;
      background: #fff;

      &.col-count, &.col-total { text-align: right; }
    }
  }

  tbody tr {
    border-bottom: 1px solid #f5f7fa;
    transition: background 0.15s;

    &:last-child { border-bottom: none; }
    &:hover td { background: #f8fbff; }

    td { padding: 9px 12px; color: #2d3748; vertical-align: middle; }
  }

  tfoot tr { border-top: 2px solid #eef0f8; }
}

.col-num   { color: #a0aab8; font-size: 12px; width: 44px; white-space: nowrap; }
.col-name  { font-weight: 500; color: $dark; max-width: 200px; word-break: break-word; }
.col-count { text-align: right; font-variant-numeric: tabular-nums; color: #4a5568; width: 72px; min-width: 72px; }
.col-total { text-align: right; font-weight: 700; color: $dark; font-variant-numeric: tabular-nums; width: 80px; white-space: nowrap; }

.grand-total-row {
  td { padding: 11px 12px; background: #f8fbff; }
}

.gt-label {
  text-align: right;
  font-weight: 700;
  font-size: 13px;
  color: $dark;
  letter-spacing: 0.2px;
}

.gt-value {
  font-size: 14px;
  color: $blue;
}
</style>
